import angular from 'angular';
import searchComponent from './search.component';
import fancyBoxModule from '../../../modules/fancybox-plus/fancybox-plus';
import imageFallbackDirective from './image-fallback.directive';

let states = [
    {
        name: 'search',
        url: '/search?q&original_type',
        component: 'search',
    }
];

let moduleNames = [fancyBoxModule];

let searchModule = angular.module('search', moduleNames)

    .component('search', searchComponent)
    .directive('imageFallback', imageFallbackDirective)
    .name;


export default {name: searchModule, states: states};



// WEBPACK FOOTER //
// ./src/app/components/page/search/search.js